import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class RatesFooterService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }
    /**
   * Description: Método que llama el servicio web de obtener las tarifas
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getRateList(category) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_RATES_LIST, category);
  }
}
